import { render, staticRenderFns } from "./activityTable.vue?vue&type=template&id=16195e93&scoped=true&"
import script from "./activityTable.vue?vue&type=script&lang=js&"
export * from "./activityTable.vue?vue&type=script&lang=js&"
import style0 from "./activityTable.vue?vue&type=style&index=0&id=16195e93&prod&scoped=true&lang=scss&"
import style1 from "./activityTable.vue?vue&type=style&index=1&id=16195e93&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16195e93",
  null
  
)

export default component.exports